import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Conta',
  edit: 'Editar perfil',
} satisfies TranslationTree;
